export default __webpack_public_path__ + "static/media/waiting.b4816774.png";